var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30156 1.4748C3.30156 1.29578 3.37268 1.12409 3.49926 0.997508C3.62585 0.87092 3.79754 0.799805 3.97656 0.799805H10.7266C10.9056 0.799805 11.0773 0.87092 11.2039 0.997508C11.3304 1.12409 11.4016 1.29578 11.4016 1.4748C11.4016 1.65383 11.3304 1.82551 11.2039 1.9521C11.0773 2.07869 10.9056 2.1498 10.7266 2.1498H8.07156L5.73156 13.8498H8.02656C8.20558 13.8498 8.37727 13.9209 8.50386 14.0475C8.63045 14.1741 8.70156 14.3458 8.70156 14.5248C8.70156 14.7038 8.63045 14.8755 8.50386 15.0021C8.37727 15.1287 8.20558 15.1998 8.02656 15.1998H1.27656C1.09754 15.1998 0.925852 15.1287 0.799265 15.0021C0.672678 14.8755 0.601563 14.7038 0.601562 14.5248C0.601562 14.3458 0.672678 14.1741 0.799265 14.0475C0.925852 13.9209 1.09754 13.8498 1.27656 13.8498H3.93156L6.27156 2.1498H3.97656C3.79754 2.1498 3.62585 2.07869 3.49926 1.9521C3.37268 1.82551 3.30156 1.65383 3.30156 1.4748Z",
    fill: "#1D1C1D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicIcon);
export default __webpack_public_path__ + "static/media/italic-icon.a8568758038e3e490edd58989050cbb7.svg";
export { ForwardRef as ReactComponent };